import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import SafeImage from 'components/SafeImage'
import axios from 'axios'
import { SystemContext } from 'utils/context';
import PaymentModal from 'components/PaymentModal';
import Modal from 'components/Modal';

function ExamDetail() {
  const [data, setData] = useState(null)
  const [qrData, setQrData] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [showModeModal, setShowModeModal] = useState(false)
  const [randomCount, setRandomCount] = useState('')
  const [selectedMode, setSelectedMode] = useState(null) // 'browse' | 'random' | 'mock'

  const context = useContext(SystemContext)
  const {examId} = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    getData()
  },[])
  
  useEffect(() => {
    getData()
    window.scrollTo({top: 0, left: 0, behavior: "smooth"})
  },[examId])

  const getData = () => {
    axios({
      method:'GET',
      url: `exam/${examId}`
    }).then((res) => {
      setData(res.data)
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleBuyBtn = () => {
    axios({
      method: 'POST',
      url: 'exam/invoice',
      data: {examId: examId}
    }).then((res) => {
      setQrData(res.data)
      context.action.handlePaymentModal(true)
    }).catch((err) => {
      console.log(err)
    })
  }

  return (
    <div className='max-w-7xl mx-auto px-3'>
      <PaymentModal show={context.state.showPaymentModal} qrData={qrData} detailData={data}/>

      {/* Mode selection modal */}
      {showModeModal && (
        <div className='fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4'>
          <div className='bg-white rounded-2xl shadow-xl w-full max-w-md p-6'>
            <h3 className='text-lg font-bold text-slate-800 mb-1'>Шалгалтын горим сонгох</h3>
            {(() => {
              const inv = data?.student_course_invoices?.[0]
              const expireDate = inv?.expireDate
              const accessDays = data?.accessExpireDays || 0
              if (!expireDate && accessDays === 0) return (
                <p className='text-sm text-slate-500 mb-4'>Хязгааргүй хугацаанд нэвтрэх боломжтой</p>
              )
              if (expireDate) {
                const remaining = Math.ceil((new Date(expireDate) - new Date()) / 86400000)
                const expired = remaining <= 0
                return (
                  <div className={`text-sm mb-4 px-3 py-2 rounded-lg font-medium ${expired ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-700'}`}>
                    {expired
                      ? `Хугацаа дууссан: ${new Date(expireDate).toLocaleDateString('mn-MN')}`
                      : `Үлдсэн хугацаа: ${remaining} хоног (${new Date(expireDate).toLocaleDateString('mn-MN')} хүртэл)`}
                  </div>
                )
              }
              return <p className='text-sm text-slate-500 mb-4'>Горимоо сонгоно уу</p>
            })()}

            {(() => {
              const inv = data?.student_course_invoices?.[0]
              const expireDate = inv?.expireDate
              const isExpired = expireDate && new Date() > new Date(expireDate)
              return isExpired ? (
                <div className='text-center py-4 text-red-500 font-medium'>Шалгалтын хугацаа дууссан байна</div>
              ) : null
            })()}
            <div className='space-y-3'>
              {/* Mode 1: Browse */}
              {(() => {
                const inv = data?.student_course_invoices?.[0]
                const isExpired = inv?.expireDate && new Date() > new Date(inv.expireDate)
                return (
              <button
                onClick={() => !isExpired && navigate(`../browse-exam/${examId}`)}
                disabled={!!isExpired}
                className={`w-full flex items-start gap-4 p-4 border-2 rounded-xl transition-all text-left group ${isExpired ? 'border-slate-200 opacity-50 cursor-not-allowed' : 'border-slate-200 hover:border-blue-400 hover:bg-blue-50'}`}
              >
                <div className='w-10 h-10 rounded-full bg-blue-100 group-hover:bg-blue-200 flex items-center justify-center shrink-0 text-blue-600 text-lg'>📖</div>
                <div>
                  <div className='font-semibold text-slate-800'>Нэг нэгээр харах</div>
                  <div className='text-xs text-slate-500 mt-0.5'>Бүх асуулт, зөв хариулттай нь дарааллан харах. Хугацаа байхгүй.</div>
                  <div className='text-xs text-blue-500 mt-0.5 font-medium'>Хязгааргүй</div>
                </div>
              </button>
              )})()}

              {/* Mode 2: Random N */}
              <div className='border-2 border-slate-200 rounded-xl p-4'>
                <div className='flex items-start gap-4'>
                  <div className='w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center shrink-0 text-amber-600 text-lg'>🎲</div>
                  <div className='flex-1'>
                    <div className='font-semibold text-slate-800'>Санамсаргүй тест</div>
                    <div className='text-xs text-slate-500 mt-0.5 mb-3'>Хэдэн асуулт өгөхөө оруулаад санамсаргүй дарааллаар тест өгнө.</div>
                    <div className='flex gap-2'>
                      <input
                        type='number'
                        min='1'
                        max={data?.exam_questions?.length || 200}
                        value={randomCount}
                        onChange={e => setRandomCount(e.target.value)}
                        placeholder={`Тоо оруулна уу (max ${data?.exam_questions?.length || '?'})`}
                        className='flex-1 border border-slate-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:border-blue-400'
                      />
                      <button
                        disabled={!randomCount || Number(randomCount) < 1}
                        onClick={() => navigate(`../getexams/${examId}`, { state: { mode: 'random', count: Number(randomCount) } })}
                        className='bg-amber-500 hover:bg-amber-600 disabled:opacity-40 text-white px-4 py-1.5 rounded-lg text-sm font-medium transition-colors'
                      >
                        Эхлэх
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mode 3: Mock */}
              {(() => {
                const limit = data?.mockTestLimit || 0
                const used = data?.student_exams?.[0]?.mockAttemptCount || 0
                const remaining = limit > 0 ? limit - used : null
                const exhausted = remaining !== null && remaining <= 0
                return (
                  <button
                    onClick={() => !exhausted && navigate(`../getexams/${examId}`, { state: { mode: 'mock' } })}
                    disabled={exhausted}
                    className={`w-full flex items-start gap-4 p-4 border-2 rounded-xl transition-all text-left group
                      ${exhausted
                        ? 'border-slate-200 opacity-50 cursor-not-allowed'
                        : 'border-slate-200 hover:border-green-400 hover:bg-green-50'}`}
                  >
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 text-lg
                      ${exhausted ? 'bg-slate-100' : 'bg-green-100 group-hover:bg-green-200 text-green-600'}`}>
                      🏆
                    </div>
                    <div className='flex-1'>
                      <div className='font-semibold text-slate-800'>Жинхэнэ шалгалт</div>
                      <div className='text-xs text-slate-500 mt-0.5'>Тохиргооны дагуу бүлгүүдээс санамсаргүй асуулт сонгон, цаг хэмжиж шалгалт өгнө.</div>
                      {limit > 0 && (
                        <div className={`text-xs mt-1.5 font-semibold ${exhausted ? 'text-red-500' : 'text-green-600'}`}>
                          {exhausted
                            ? `Эрх дууссан (${used}/${limit} удаа өгсөн)`
                            : `Үлдсэн эрх: ${remaining} удаа (${used}/${limit})`}
                        </div>
                      )}
                      {limit === 0 && <div className='text-xs mt-1 text-green-600'>Хязгааргүй</div>}
                    </div>
                  </button>
                )
              })()}
            </div>

            <button onClick={() => setShowModeModal(false)} className='mt-4 w-full py-2 rounded-xl border border-slate-300 text-slate-600 hover:bg-slate-50 text-sm'>
              Буцах
            </button>
          </div>
        </div>
      )}
      <div className='py-6'>
        {
          data &&
          <>
            <div className='flex xs:flex-col md:flex-row gap-7'>
              <div className='flex flex-col md:w-2/3 xs:w-full gap-7'>
                <div className='card p-0'>
                  <div className='flex'>
                    <SafeImage src={`${process.env.REACT_APP_ASSET_URL}${data?.image}`} width='100%'/>
                  </div>       
                  <div className='p-4'>
                    <div className='text-xl mb-3' >Танилцуулга</div>
                    <div className='prose prose-md contents dark:text-white text-sm' dangerouslySetInnerHTML={{__html: data?.descr}}></div>
                  </div>        
                </div>
              </div>

                {/*-------------------------- SIDEBAR ------------------------------*/ }

              <div className='flex flex-col md:w-1/3 xs:w-full gap-7'>
                <div className='card flex flex-col '>
                  <h3 className='mt-0 text-lg leading-5 font-medium'>{data?.title}</h3>
                  <ul className='divide-y dark:divide-slate-700'>
                    <li className='py-2 flex justify-between'>
                      <div className='flex items-center gap-2 text-gray-600 font-medium'>
                        <div className='flex text-lg'><ion-icon name="list-outline"/></div>
                        <div>Нийт асуулт:</div>
                      </div>
                      <div>{data?.exam_questions?.length ?? 0}</div>
                    </li>
                    <li className='py-2 flex justify-between'>
                      <div className='flex items-center gap-2 text-gray-600 font-medium'>
                        <div className='flex text-lg'><ion-icon name="time-outline"/></div>
                        <div>Хугацаа:</div> 
                      </div>
                      <div>{data?.testMinute} мин</div> 
                    </li>
                    <li className='py-2 flex justify-between'>
                      <div className='flex items-center gap-2 text-gray-600 font-medium'>
                        <div className='flex text-lg'><ion-icon name="pricetag-outline"/></div>
                        <div>Үнэ:</div>
                      </div>
                      <div>{new Intl.NumberFormat().format(data?.price)} ₮</div>
                    </li>
                    <li className='py-2' style={{ height:'460px'}}>
                      <div className='flex items-center gap-2 text-gray-600 font-medium'>
                        {/* <div className='flex text-lg'><ion-icon name="ribbon-outline"/></div> */}
                        {/* <div>Гэрчилгээ:</div> */}
                      </div>
                      <div className='mt-2 flex justify-center'>
                        {/* <iframe style={{ height:'400px'}} width='auto' src={`${process.env.REACT_APP_ASSET_URL}${data.certTemplate}#toolbar=0`}/> */}
                      </div>                      
                    </li>
                  </ul>
                  {(() => {
                    const invoiceStatus = data?.student_course_invoices?.[0]?.status;
                    // DB-д ENUM хэлбэрээр хадгалагдана: 'Үүссэн' (төлбөр хүлээгдэж буй), 'Төлөгдсөн' (төлөгдсөн).
                    // Хуучин тоон утгуудыг (1/2) мөн зэрэгцүүлж дэмжинэ.
                    const isPaid = invoiceStatus === 'Төлөгдсөн' || invoiceStatus === 2 || invoiceStatus === '2';
                    const isPending = invoiceStatus === 'Үүссэн' || invoiceStatus === 1 || invoiceStatus === '1';
                    if (!invoiceStatus) {
                      return (
                        <button className='flex justify-center items-center bg-blue-200 text-blue-600 hover:bg-blue-300 duration-150 px-4 py-2 rounded-md text-sm font-medium mx-auto mt-4' onClick={handleBuyBtn}>
                          <ion-icon name="cart-outline" style={{fontSize:'18px'}}/>
                          <span className='ml-2'>ХУДАЛДАЖ АВАХ</span>
                        </button>
                      );
                    }
                    if (isPending) {
                      return (
                        <button className='flex justify-center items-center bg-orange-200 text-orange-600 hover:bg-orange-300 duration-150 px-4 py-2 rounded-md text-sm font-medium mx-auto mt-4' onClick={handleBuyBtn}>
                          <ion-icon name="card-outline" style={{fontSize:'18px'}}/>
                          <span className='ml-2'>ТӨЛӨХ</span>
                        </button>
                      );
                    }
                    if (isPaid) {
                      return (
                        <button className='flex justify-center items-center bg-green-500 hover:bg-green-600 text-white duration-150 px-4 py-2 rounded-xl text-sm font-semibold mx-auto mt-4 w-full' onClick={() => setShowModeModal(true)}>
                          <span>ШАЛГАЛТ ӨГӨХ</span>
                        </button>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            </div>
          </>
        }
      </div>
    </div>
  )
}

export default ExamDetail